import PreUI from 'pre-ui';

import NioAlert from '@/components/UI/NioAlert.vue';
import NioBadge from '@/components/UI/NioBadge.vue';
import NioButton from '@/components/UI/NioButton.vue';
import NioButtonGroup from '@/components/UI/NioButtonGroup.vue';
import NioDatepicker from '@/components/UI/NioDatepicker.vue';
import NioDatetimepicker from '@/components/UI/NioDatetimepicker.vue';
import NioDropdown from '@/components/UI/NioDropdown.vue';
import NioDropdownItem from '@/components/UI/NioDropdownItem.vue';
import NioEmojiPicker from '@/components/UI/NioEmojiPicker.vue';
import NioIcon from '@/components/UI/NioIcon.vue';
import NioInput from '@/components/UI/NioInput.vue';
import NioInputGroup from '@/components/UI/NioInputGroup.vue';
import NioNotifications from '@/components/UI/NioNotifications.vue';
import NioOptional from '@/components/UI/NioOptional.vue';
import NioPopup from '@/components/UI/NioPopup.vue';
import NioProgress from '@/components/UI/NioProgress.vue';
import NioSelect from '@/components/UI/NioSelect.vue';
import NioSpinner from '@/components/UI/NioSpinner.vue';
import NioTable from '@/components/UI/NioTable.vue';
import NioTabs from '@/components/UI/NioTabs.vue';
import NioTextarea from '@/components/UI/NioTextarea.vue';
import NioTimepicker from '@/components/UI/NioTimepicker.vue';
import NioToggle from '@/components/UI/NioToggle.vue';

export default {
    install(Vue) {
        Vue.use(PreUI, {
            notifications: {
                placement: 'top-center',
            },
        });

        Vue.component('NioAlert', NioAlert);
        Vue.component('NioBadge', NioBadge);
        Vue.component('NioButton', NioButton);
        Vue.component('NioButtonGroup', NioButtonGroup);
        Vue.component('NioDatepicker', NioDatepicker);
        Vue.component('NioDatetimepicker', NioDatetimepicker);
        Vue.component('NioDropdown', NioDropdown);
        Vue.component('NioDropdownItem', NioDropdownItem);
        Vue.component('NioEmojiPicker', NioEmojiPicker);
        Vue.component('NioIcon', NioIcon);
        Vue.component('NioInput', NioInput);
        Vue.component('NioInputGroup', NioInputGroup);
        Vue.component('NioNotifications', NioNotifications);
        Vue.component('NioOptional', NioOptional);
        Vue.component('NioPopup', NioPopup);
        Vue.component('NioProgress', NioProgress);
        Vue.component('NioSelect', NioSelect);
        Vue.component('NioSpinner', NioSpinner);
        Vue.component('NioTable', NioTable);
        Vue.component('NioTabs', NioTabs);
        Vue.component('NioTextarea', NioTextarea);
        Vue.component('NioTimepicker', NioTimepicker);
        Vue.component('NioToggle', NioToggle);
    },
};
